var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-body",style:({height: _vm.height + 'px'}),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }